import "./App.css";
import { Routes, Route, Link, useLocation } from "react-router-dom";
import Homescreen from "./Homescreen";
import icon from "./Assets/icon.png";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import "bootstrap/dist/css/bootstrap.min.css";
import servesIcon from "./Assets/servesIcon.png";
import drivesIcon from "./Assets/drivesIcon.png";
import homeIcon from "./Assets/myDaddysHomeIcon.png";
import ApplicationForm from "./Components/ApplicationForm";
import Login from "./Components/Login";
import Register from "./Components/Register";
import Newsroom from "./Components/Newsroom";
import Careers from "./Components/Careers";
import BackToTop from "./Components/BackToTop";
import GoogleTranslate from "./Components/GoogleTranslate";
import PartnerPage from "./Components/PartnerPage";
import { HashLink } from "react-router-hash-link";
import TenderPayment from "./Components/Projects/TenderPayment";
import Project01 from "./Components/Projects/Project01";
import Project02 from "./Components/Projects/Project02";
import Project03 from "./Components/Projects/Project03";

function App() {
  const location = useLocation();
  const isLoginActive =
    location.pathname.includes("/login") ||
    location.pathname.includes("/register") ||
    location.pathname.includes("/payments") ||
    location.pathname.includes("/project01") ||
    location.pathname.includes("/project02") ||
    location.pathname.includes("/project03");

  return (
    <div className="App">
      {isLoginActive ? (
        <></>
      ) : (
        <div className="nav1-container">
          <div className="navbar1">
            <div className="nav1">
              <Link to="/">
                <img className="icon" src={icon} alt="icon" />
              </Link>
              <div className="nav1-right">
                <div className="newsroom">
                  <ul>
                    <li className="tender-link">
                      <Link to="/payments">Projects</Link>
                    </li>
                    <span className="hr"></span>
                    <li>
                      <Link to="/newsroom">Newsroom</Link>
                    </li>
                    <span className="hr"></span>
                    <li>
                      <Link to="/careers">Careers</Link>
                    </li>
                    <span className="hr"></span>
                    <li>
                      <GoogleTranslate />
                    </li>
                  </ul>
                </div>
                <div className="nav1-list">
                  <ul>
                    <li>
                      <a href="/#home">Home</a>
                    </li>
                    <li>
                      <DropdownButton
                        id="dropdown-basic-button"
                        title="About Us"
                        className="my-dropdown"
                      >
                        <Dropdown.Item>
                          <HashLink to="/#aboutUs">About Us Info</HashLink>
                        </Dropdown.Item>
                        <Dropdown.Item
                          href="https://icorp.global/Video/ICorpPaysOverview.mp4"
                          target="_blank"
                        >
                          ICorp Pays Overview
                        </Dropdown.Item>
                      </DropdownButton>
                    </li>

                    <li>
                      <DropdownButton
                        id="dropdown-basic-button"
                        title="Services"
                        className="my-dropdown"
                      >
                        <Dropdown.Item>
                          <HashLink to="/#serves">
                            <img className="service-icons" src={servesIcon} />
                          </HashLink>
                        </Dropdown.Item>
                        <Dropdown.Item>
                          <HashLink to="/#drives">
                            <img
                              className="service-icons icon2"
                              src={drivesIcon}
                            />
                          </HashLink>
                        </Dropdown.Item>
                        <Dropdown.Item>
                          <HashLink to="/#myHome">
                            <img
                              className="service-icons myHome-icon"
                              src={homeIcon}
                            />
                          </HashLink>
                        </Dropdown.Item>
                      </DropdownButton>
                    </li>
                    <li
                      className={
                        location.pathname.includes("/partners") ? "active" : ""
                      }
                    >
                      <a href="/partners">Partners</a>
                    </li>
                    <li>
                      <HashLink to="/#contactUs">Contact Us</HashLink>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {isLoginActive ? (
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/payments" element={<TenderPayment />} />
          <Route path="/project01" element={<Project01 />} />
          <Route path="/project02" element={<Project02 />} />
          <Route path="/project03" element={<Project03 />} />
        </Routes>
      ) : (
        <div className="main-main-panel">
          <Routes>
            <Route path="/" element={<Homescreen />} />
            <Route path="/form" element={<ApplicationForm />} />
            <Route path="/newsroom" element={<Newsroom />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/partners" element={<PartnerPage />} />
            <Route path="/payments" element={<TenderPayment />} />
            <Route path="/project01" element={<Project01 />} />
            <Route path="/project02" element={<Project02 />} />
            <Route path="/project03" element={<Project03 />} />
          </Routes>
          <BackToTop />
        </div>
      )}
    </div>
  );
}

export default App;
